import {useGetAndSet} from "./useGetAndSet";
import {createSetInvoicesDataAction} from "../actions/dataActions";

export const useInvoicesData = (params, dataFresh) => {
    return useGetAndSet("invoices", params, createSetInvoicesDataAction, dataFresh);
}